<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>To Rita Schuster and Audrey Kane,<br/>moms with memories of gold and silver,<br/>and to aunt Dorothy Cunningham,<br/>keeper of the treasure of laughs.</p>
<p class="noindent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1c63c8d5